import { render } from "./DBunga.vue?vue&type=template&id=73ba7886"
import script from "./DBunga.vue?vue&type=script&lang=js"
export * from "./DBunga.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__